import { useEffect, useState } from "react";
import { fetchAdvanceCashData } from "../Api/ViewAdvanceCashData";
import { Container, Table } from "react-bootstrap";
//import "../Styling/ViewAdvanceCashData.css";
import { toast } from "react-toastify";
import moment from "moment";

const ViewAdvanceCashData = () => {
  const [advanceCashData, setAdvanceCashData] = useState([]);

  useEffect(() => {
    const loadAdvanceCashData = async () => {
      try {
        const data = await fetchAdvanceCashData();
        setAdvanceCashData(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Advance Cash Data`);
      }
    };

    loadAdvanceCashData();
  }, []);

  return (
    <>
        <div className="main-content expand">
          <Container fluid className="list-container">
            <span className="list-title">View Advance Cash Data</span>

            {advanceCashData.length > 0 ? (
              <div className="table-wrapper">
                <div className="table-scroll-container">
                  <Table bordered hover className="data-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Advance Request Id</th>
                        <th>Purpose of Advance</th>
                        <th>Destination</th>
                        <th>Date of Travel</th>
                        <th>Advance Amount Requested</th>
                        <th>Date of Request</th>
                        <th>Approval Authority</th>
                        <th>Mode of Advance Disbursement</th>
                        <th>Approval Status</th>
                        <th>Created At</th>
                        <th>Created By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {advanceCashData.map((data, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{data.advanceReqId}</td>
                          <td>{data.purposeOfAdvance}</td>
                          <td>{data.destination}</td>
                          <td>{new Date(data.datesOfTravel).toLocaleDateString()}</td>
                          <td>{data.advanceAmountRequested}</td>
                          <td>{new Date(data.dateOfRequest).toLocaleDateString()}</td>
                          <td>{data.approvalAuthority}</td>
                          <td>{data.modeOfAdvanceDisbursement}</td>
                          <td>{data.approvalStatus}</td>
                          <td>{moment(data.createdAt).format('L')}</td>
                          <td>{data.createdBy}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            ) : (
              <p className="no-data">No advance cash data found.</p>
            )}
          </Container>
        </div>
    </>
  );
};

export default ViewAdvanceCashData;